import { useAuth } from './useAuth';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

export const useAuthGAEvents = () => {
  const { loginCount } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const gaEvent = searchParams.get('_gl');

  useEffect(() => {
    const isGAEventTriggerRequired = gaEvent && loginCount;

    if (isGAEventTriggerRequired) {
      // GA events storage in upper scope application
      const dataLayer = (window as { dataLayer?: { push: Function } })?.dataLayer;

      if (dataLayer?.push) {
        dataLayer?.push({
          event: 'gaEvent',
          name: 'login_completed',
        });

        // if first login, trigger also signup_completed event
        if (loginCount === 1) {
          dataLayer?.push({
            event: 'gaEvent',
            name: 'signup_completed',
          });
        }
      }

      searchParams.delete('_gl');
      setSearchParams(searchParams, { replace: true });
    }
  }, [gaEvent, loginCount, setSearchParams, searchParams]);
};
